"use client";

import { useEffect, useState } from "react";

export interface UseAutoStepOptions {
  /** Clears the timer without resetting the current step. */
  paused?: boolean;
  /** Stops the timer and keeps the first step active. */
  disabled?: boolean;
}

/** Advances an index on an interval. The timer is cleared on pause, disable, and unmount. */
export function useAutoStep(
  count: number,
  intervalMs = 2200,
  { paused = false, disabled = false }: UseAutoStepOptions = {},
): number {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (disabled) setActive(0);
  }, [disabled]);

  useEffect(() => {
    if (paused || disabled || count < 1) return;
    const id = window.setInterval(() => {
      setActive((current) => (current + 1) % count);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [count, intervalMs, paused, disabled]);

  return disabled ? 0 : active;
}
